/** Builder section types of the `reset` templates. No imports: `entities/LandingPage` reads it. */
export const resetSectionTypes = [
  "resetLandingEffects",
  "resetHeader",
  "resetHero",
  "resetPain",
  "resetRules",
  "resetSolution",
  "resetStack",
  "resetBonuses",
  "resetGuarantee",
  "resetTestimonial",
  "resetLongTerm",
  "resetTimeline",
  "resetOffer",
  "resetFaq",
  "resetStickyCta",
  "resetCheckout",
  "resetThankYou",
] as const;
